import { parsePhoneNumberFromString } from 'libphonenumber-js';

export const prettyPhone = (phone: string) => {
  const parsed = parsePhoneNumberFromString(phone, 'US');
  if (!parsed) return phone;
  return parsed.formatNational();
};
